import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ProjectExhibitSettings =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ProjectExhibitSettings, _BaseData);

  function ProjectExhibitSettings() {
    _classCallCheck(this, ProjectExhibitSettings);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProjectExhibitSettings).call(this, "ProjectExhibitSettings"));
  }

  _createClass(ProjectExhibitSettings, [{
    key: "GetSettings",
    value: function () {
      var _GetSettings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(projectId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetSettings/").concat(projectId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetSettings(_x) {
        return _GetSettings.apply(this, arguments);
      }

      return GetSettings;
    }()
  }, {
    key: "GetExceptionSettings",
    value: function () {
      var _GetExceptionSettings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(projectId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetExceptionSettings/").concat(projectId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetExceptionSettings(_x2) {
        return _GetExceptionSettings.apply(this, arguments);
      }

      return GetExceptionSettings;
    }()
  }, {
    key: "AlwaysAllowEntry",
    value: function () {
      var _AlwaysAllowEntry = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(projectId, exhibitId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/AlwaysAllowEntry/").concat(projectId, "/").concat(exhibitId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function AlwaysAllowEntry(_x3, _x4) {
        return _AlwaysAllowEntry.apply(this, arguments);
      }

      return AlwaysAllowEntry;
    }()
  }]);

  return ProjectExhibitSettings;
}(BaseData);

export default new ProjectExhibitSettings();